import api from './client'

// --- Parcelle (données agrégées : BDNB, DVF, SITADEL, RNIC) ---

export const getParcelleData = (parcelle_id) =>
  api.get(`/data/parcelle/${parcelle_id}`)

export const getParcellesData = (parcelle_ids) =>
  api.get('/data/parcelles', { ids: parcelle_ids.join(',') })

// --- Localisation (par coordonnées GPS) ---

export const getDpeNear = (lon, lat, radius_m = 500, limit = 20) =>
  api.get('/data/dpe/near', { lon, lat, radius_m, limit })

export const getDesserteNear = (lon, lat, radius_m = 1000) =>
  api.get('/data/desserte', { lon, lat, radius_m })

export const getBpeNear = (lon, lat, radius_m = 500, domaine = null, limit = 50) =>
  api.get('/data/bpe/near', { lon, lat, radius_m, ...(domaine && { domaine }), limit })

export const getBpeCommuneDensity = (code_commune) =>
  api.get(`/data/bpe/commune/${code_commune}`)

export const getLoyersCommune = (code_commune, type_logement = null) =>
  api.get(`/data/loyers/${code_commune}`, { ...(type_logement && { type_logement }) })

export const getIndicesPrix = (geo_code, segment = 'logements_anciens', geo_level = 'communal') =>
  api.get('/data/indices', { segment, geo_level, geo_code })

// --- DVF Mutations (recherche par rayon pour import) ---

export const searchDvfMutations = (params) =>
  api.get('/data/dvf/mutations/search', params)
